<template>
  <div class="user">
    <router-view>sdfsdfsfs</router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.user {
  width: 100%;
  height: 100%;
  // background: #fff;
}
</style>
